import type { CohortNames, Experiment } from '@bridebook/toolbox/src/ab-testing/lib/types';

/**
 * Extracts JIRA ticket id and code-friendly test name (without spaces etc.)
 * from test id
 */
export const destructTestId = (testId?: string) => {
  const split = testId?.split('_') || [];
  return {
    ticketId: split[0] || '',
    name: split[1] || '',
  };
};

/**
 * Generates an analytics payload for a user participating in an A/B test.
 *
 * This function creates an object representing the event data to be sent to analytics
 * when a user participates in an A/B test.
 *
 */
export const getParticipatedInAbTestPayload = ({
  abTest: { id, name },
  variant,
}: {
  abTest: Experiment;
  variant: CohortNames;
}) => ({
  event: 'User participated in test',
  testId: id,
  testName: name,
  testVariant: variant,
});
